import { render, staticRenderFns } from "./TokenLoggingButton.vue?vue&type=template&id=b6fc70ae&"
import script from "./TokenLoggingButton.vue?vue&type=script&lang=ts&"
export * from "./TokenLoggingButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports